import React from "react"
import PropTypes from "prop-types"
import { useStaticQuery, graphql } from "gatsby"
import { Layout } from "antd"

import Header from "./Header"
import Footer from "./Footer"
import "../styles/antd-custom.less"

const { Content } = Layout

const AppLayout = ({ children, footer, layoutClassname, contentClassName }) => {
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `)

  return (
    <Layout className={layoutClassname}>
      <Header />
      <Content className={contentClassName}>{children}</Content>
      {footer && <Footer />}
    </Layout>
  )
}

AppLayout.propTypes = {
  children: PropTypes.node.isRequired,
  footer: PropTypes.bool,
  layoutClassname: PropTypes.string,
  contentClassName: PropTypes.string,
}

AppLayout.defaultProps = {
  footer: true,
  layoutClassname: "",
  contentClassName: "",
}

export default AppLayout
